import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@uhg-abyss/web/ui/Link';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { Box } from '@uhg-abyss/web/ui/Box';

const PictureCardContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '12px',
});

const StyledBox = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '28px',
  width: '100%',
  minHeight: '100%',
  boxShadow:
    'rgb(0 0 0 / 5%) 0px 1px 3px, rgb(0 0 0 / 5%) 0px 10px 15px -5px,rgb(0 0 0 / 4%) 0px 7px 7px -5px',
  borderRadius: '3px',
  border: '1px solid $gray4',
});

const LeftContainer = styled('div', {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
});

const IconContainer = styled('div', {});

const TextContainer = styled('h6', {
  display: 'flex',
  color: '$primary1',
  fontSize: '20px !important',
  fontWeight: '$bold',
  gap: '8px',
});

const RightContainer = styled('div', {
  whiteSpace: 'nowrap',
});

const LinkContainer = styled('div', {
  alignSelf: 'flex-end',
});

const onClick = (title, date, url) => {
  event('YOUR_FEATURED_NEWS_WIDGET_CLICK', {
    interactionValue: 'View details',
    interactionContext: `${title} ${date}`,
  });

  event('EXIT_LINK_NAVIGATE_YOUR_FEATURED_NEWS', {
    linkText: 'View details',
    linkUrl: url || '',
  });
};

export const PictureCardSmallerScreen = ({ pictureCardContent }) => {
  return (
    <PictureCardContainer>
      <For each='pictureCard' of={pictureCardContent}>
        <StyledBox key={`picture-card-id-${pictureCard.title}`} color='white'>
          <LeftContainer>
            <IconContainer data-testid={pictureCardContent.dataTestidIcon}>
              {pictureCard.icon}
            </IconContainer>
            <TextContainer data-testid={pictureCardContent.dataTestidLabel}>
              {pictureCard.title} {pictureCard.date}
            </TextContainer>
          </LeftContainer>
          <RightContainer>
            <LinkContainer>
              <Link
                href={pictureCard.url}
                fontWeight='bold'
                onClick={() =>
                  onClick(pictureCard.title, pictureCard.date, pictureCard.url)
                }
              >
                View details
              </Link>
            </LinkContainer>
          </RightContainer>
        </StyledBox>
      </For>
    </PictureCardContainer>
  );
};

PictureCardSmallerScreen.propTypes = {
  pictureCardContent: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
